import { queryOptions } from '@tanstack/react-query';
import type { DuoPreferencesResponse, GetData } from 'generated/openapi';

import { PrivateApi } from '@/shared/api/httpClient';

export const getDuoPreferencesKey = () =>
  ['users', '@me', 'duo-preferences'] as const;

const getDuoPreferencesUrl: GetData['url'] = 'duo-preferences';

export const getDuoPreferencesOptions = <T = DuoPreferencesResponse>() =>
  queryOptions<DuoPreferencesResponse, unknown, T>({
    queryKey: getDuoPreferencesKey(),
    queryFn: () =>
      PrivateApi.get(getDuoPreferencesUrl).json<DuoPreferencesResponse>(),
  });
